import { FileIdentifier, MediaClient } from '@atlaskit/media-client';
import { MediaClientConfig } from '@atlaskit/media-core';

import { Attachment, CollectionName, MediaAuthParams } from './types';

const createMediaClientConfig = (
  mediaAuth: MediaAuthParams
): MediaClientConfig => {
  const mediaClient = new MediaClient({
    authProvider: () => Promise.resolve(mediaAuth),
  });

  return mediaClient.config;
};

// converts attachments to file identifier format
// this format is required by all AK media components
const buildMediaIdentifiers = ({
  attachments,
  collectionName,
}: {
  attachments: Attachment[];
  collectionName: CollectionName;
}): FileIdentifier[] => {
  return attachments.map(attachment => ({
    collectionName,
    id: attachment.uuid,
    mediaItemType: 'file',
  }));
};

// returns an attachment for a specific file identifier (if exists)
// matches identifier id to attachment uuid
const findByIdentifier = ({
  attachments,
  identifier,
}: {
  attachments: Attachment[];
  identifier: FileIdentifier;
}): Attachment | undefined => {
  return attachments.find(attachment => attachment.uuid === identifier.id);
};

export { buildMediaIdentifiers, createMediaClientConfig, findByIdentifier };
